import React, { useContext } from 'react';
// @ts-ignore
import logo from '../../assets/icons/hat-data-rights-icon.svg';
import HmiContext from '../../context/HmiContext';
import FormatMessage from '../../messages/FormatMessage';

const HmiHeader: React.FC = () => {
  const hmiContext = useContext(HmiContext);
  const { parentApp } = hmiContext.hmi;

  if (!parentApp) {
    return null;
  }
  const hmiDescription = parentApp.info.hmiDescription;

  return (
    <div className={'hmi-header-wrapper'}>
      <img
        className={'hmi-data-rights-img'}
        src={logo}
        alt={'HAT Data rights protected'}
      />

      <div className={'hmi-section-title'}>
        <FormatMessage
          id={'hmi.readWrite.wantAccessTo'}
          values={{ name: parentApp.info.name }}
        />
      </div>

      <div className={'hmi-text-grey'}>{hmiDescription}</div>

      <div className={'hmi-separator'} />
    </div>
  );
};

export default HmiHeader;
